import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@mui/material';

import './CustomDrawer.scss';

const CustomDrawer = ({ isOpen, size, handleClose, children }) => {
  return (
    <Drawer
      anchor="right"
      className={`custom-drawer ${isOpen ? 'custom-drawer_visible' : 'custom-drawer_hidden'} ${size && size}`}
      open={isOpen}
      onClose={handleClose}
    >
      {children}
    </Drawer>
  );
};

CustomDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  size: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default CustomDrawer;
